
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/acceptcredit",
      function () {
        return require("private-next-pages/acceptcredit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/acceptcredit"])
      });
    }
  